export function agentZoneReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case "GET_AGENT_ZONES":
            return payload;
        
        default:
            return state;
    }
}


// -------------------- ACTIONS

export function getZoneList(){
    return async function (dispatch){
        dispatch({ type: "FETCH_AGENT_ZONES_START", payload: "" })
        try {
            const req = await fetch('/agent/zone/list',{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            })
            let list = await req.json();
            console.log('getZoneList res : ', list);
            if(!list.error){
                dispatch({
                    type: "GET_AGENT_ZONES",
                    payload: list.zoneList || []
                })
            } else {
                console.log("[ERROR] getZoneList : ", list.error);
                dispatch({ type: "FETCH_AGENT_ZONES_ERROR", payload: list.error })
                
            }            
            dispatch({ type: "FETCH_AGENT_ZONES_FULFILLED", payload: "" }) 
        } catch (error) {
            console.log("[ERROR] getZoneList : ", error);
            dispatch({ type: "FETCH_AGENT_ZONES_ERROR", payload: error })
        }
         
    }
}


